<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-buttons slot="start">
      <ion-button
        (click)="cancel()"
        [attr.aria-label]="'general.cancel' | translate"
      >
        <ion-icon
          slot="icon-only"
          aria-hidden="true"
          src="../assets/material-symbols/close_24dp.svg"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ (isEdit ? 'users.edit_user' : 'users.add_user') | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding">
  <form [formGroup]="userForm">
    <ion-grid class="">
      <ion-row>
        <ion-col
          size="12"
          size-lg="6"
        >
          <ion-input
            label="{{ 'users.name' | translate }}"
            label-placement="floating"
            fill="outline"
            mode="md"
            formControlName="firstName"
            [errorText]="getErrorMessage('firstName') | translate"
          ></ion-input>
        </ion-col>
        <ion-col
          size="12"
          size-lg="6"
        >
          <ion-input
            label="{{ 'users.last_name' | translate }}"
            label-placement="floating"
            fill="outline"
            mode="md"
            formControlName="lastName"
            [errorText]="getErrorMessage('lastName') | translate"
          ></ion-input>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col
          size="12"
          size-lg="8"
        >
          <ion-input
            type="email"
            label="{{ 'users.email' | translate }}"
            label-placement="floating"
            fill="outline"
            mode="md"
            formControlName="email"
            [errorText]="getErrorMessage('email') | translate"
          ></ion-input>
        </ion-col>
        <ion-col
          size="12"
          size-lg="4"
        >
          <ion-input
            type="tel"
            label="{{ 'users.phone' | translate }}"
            label-placement="floating"
            fill="outline"
            mode="md"
            formControlName="phone"
            [errorText]="getErrorMessage('phone') | translate"
          ></ion-input>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12">
          <div class="freight-data-block">
            <ion-icon
              aria-hidden="true"
              src="../assets/material-symbols/manage_accounts_24dp.svg"
            ></ion-icon>
            <div>
              <p class="subtitle">{{ 'users.roles_title' | translate }}</p>
            </div>
          </div>

          <ion-list lines="none">
            @for (option of roleOptions; track option.role) {
              <ion-item>
                <ion-checkbox
                  [checked]="isRoleSelected(option.role)"
                  [disabled]="isCurrentUser() || !isRoleManageable(option.role)"
                  (ionChange)="toggleRole(option.role, $event.detail.checked)"
                >
                  {{ option.labelKey | translate }}
                </ion-checkbox>
              </ion-item>
            }
          </ion-list>

          @if (showRolesError()) {
            <ion-text color="danger">
              <p class="fs-sm">{{ 'users.help.select_role' | translate }}</p>
            </ion-text>
          }

          @if (unmanageableRoleOptions().length) {
            <ion-text color="medium">
              <p class="fs-sm">
                {{ 'users.unmanageable_roles_warning' | translate: { roles: unmanageableRolesLabel() } }}
              </p>
            </ion-text>
          }
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12">
          <ion-item lines="none">
            <ion-toggle formControlName="enabled">{{ 'users.enabled' | translate }}</ion-toggle>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-grid class="ion-padding-vertical-0">
      <ion-row>
        <ion-col>
          <ion-button
            (click)="confirm()"
            color="primary"
            expand="block"
            fill="solid"
            size="large"
          >
            {{ 'general.save' | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
